var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_c('strong', {
    staticClass: "registration-title"
  }, [_vm._v(_vm._s(_vm.$t('registration.info.title')))]), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.info.title.link', {
        instagramLink: _vm.instagramLink,
        tgLink: _vm.tgLink
      }))
    }
  })]), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('registration.info.subtitle')))]), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.info.subtitle.link', {
        supportLink: _vm.supportLink
      }))
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }